const toTrimmedString = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const normaliseMessageList = (message) => {
  if (Array.isArray(message)) {
    return message.map(toTrimmedString).filter(Boolean);
  }
  const single = toTrimmedString(message);
  return single ? [single] : [];
};

const normaliseErrorItems = (errors) => {
  if (!Array.isArray(errors)) return [];

  return errors
    .map((item, index) => {
      if (!item || typeof item !== "object") return null;

      const message = toTrimmedString(item.message);
      const field = toTrimmedString(item.field);
      const rowRaw = item.row;
      const row =
        rowRaw === null || rowRaw === undefined || rowRaw === ""
          ? null
          : Number(rowRaw);

      return {
        id: `${row ?? "unknown"}-${field || "field"}-${index}`,
        row: Number.isFinite(row) ? row : null,
        field: field || null,
        code: toTrimmedString(item.code) || null,
        message:
          message ||
          (field ? `Missing or invalid field '${field}'` : "Invalid value"),
        value:
          item.value === null || item.value === undefined
            ? null
            : String(item.value),
      };
    })
    .filter(Boolean);
};

export const groupBulkErrorsByRow = (items = []) => {
  const groups = new Map();

  items.forEach((item) => {
    const key =
      item.row === null || item.row === undefined ? "unknown" : item.row;
    if (!groups.has(key)) {
      groups.set(key, {
        row: item.row,
        items: [],
      });
    }
    groups.get(key).items.push(item);
  });

  return Array.from(groups.values()).sort((a, b) => {
    if (a.row === null || a.row === undefined) return 1;
    if (b.row === null || b.row === undefined) return -1;
    return a.row - b.row;
  });
};

export const parseBulkIssuanceError = (data) => {
  if (!data || typeof data !== "object") return null;

  const explicitTitle =
    toTrimmedString(data.error) || toTrimmedString(data.title);

  const summaryMessages = normaliseMessageList(data.message);
  const items = normaliseErrorItems(data.errors);

  const displayItems =
    items.length > 0
      ? items
      : summaryMessages.map((message, index) => ({
          id: `message-${index}`,
          row: null,
          field: null,
          code: null,
          message,
          value: null,
        }));

  if (!explicitTitle && displayItems.length === 0) return null;

  const title = explicitTitle || "Unable to process the spreadsheet";

  return {
    title,
    summaryMessages,
    items: displayItems,
    groups: groupBulkErrorsByRow(displayItems),
    count: displayItems.length,
    hasDetails: displayItems.length > 0,
  };
};
